import {Button, styled} from "@mui/material";

export const InputWithSelectButton = styled(Button)(({theme}) => {
    const headerColors = theme.barekam.header;

    return {
        color: headerColors.textDark,
        minWidth: 'unset',
        height: '1.4375rem',
        alignItems: 'center',
        display: 'inline-flex',
        justifyContent: 'space-between',
        textTransform: 'none',
        marginTop: '1rem'
    }
});
